<template>
  <div class="mobile-menu">
    <div class="mobile-menu-header">
      <div class="mobile-menu-header__title">Меню</div>
      <div class="mobile-menu-header__close-button">
        <svg class="close-icon" @click="$emit('close')">
          <use xlink:href="#close"></use>
        </svg>
      </div>
    </div>

    <div class="mobile-menu-content">
      <ul class="nav flex-column main-nav">
        <li class="nav-item">
          <router-link class="nav-link" to="/competencies" exact>Оценочные материалы</router-link>
        </li>

        <li class="nav-item">
          <router-link class="nav-link" to="/archive">Архив</router-link>
        </li>

      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "MobileMenu"
};
</script>

<style lang="scss" scoped>
.mobile-menu {
  position: absolute;
  width: 100%;
  top: 0;
  left: 0;
  height: 100%;
  background-color: rgba(16, 54, 119, 0.95);
  z-index: 9999;
  padding: 30px 35px 40px 45px;
}

.mobile-menu-header {
  display: flex;
  justify-content: space-between;

  &__title {
    color: #fff;
    font-size: 30px;
    line-height: 53px;
  }

  &__close-button {
    align-self: center;
  }

  .close-icon {
    width: 29px;
    height: 29px;
  }
}

.mobile-menu-content {
  display: flex;
  flex-wrap: wrap;
  height: 100%;
  padding-top: 30px;

  .main-nav {
    flex: 1 1 100%;
  }

  .nav-item {
    margin-right: 16px;
  }

  .nav-link {
    padding: 0;
    font-size: 20px;
    line-height: 52px;
    font-weight: 400;

    &:hover {
      color: #fff;
    }
  }
}
</style>
